export default "__VITE_ASSET__Cb9pxi8E__"